import type { TextPostContainerProps } from './TextPostContainer.tsx';
import { PostType } from '@_/constants';
import { ClampText } from '@_/ui';
import { TextPostBody } from '../TextPostBody/index.ts';
import { TextPostContainer } from './TextPostContainer.tsx';

export interface TextPostProps extends Omit<TextPostContainerProps, 'children'> {}

export function TextPost({ post, ...otherProps }: TextPostProps) {
  return (
    <TextPostContainer {...otherProps} post={post}>
      {post.type === PostType.Article && !!post.contentHtml && (
        <ClampText lines={4}>
          <TextPostBody html={post.contentHtml} />
        </ClampText>
      )}
      {post.type === PostType.Text && !!post.contentText && (
        <ClampText lines={4}>
          <TextPostBody text={post.contentText} />
        </ClampText>
      )}
    </TextPostContainer>
  );
}
